import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// The button and its popover carry this attribute so a clickable parent (such as
// a category card) can ignore clicks and key presses that come from them.
export function isMetricInfoEvent(event) {
    const target = event && event.target;
    return Boolean(target && typeof target.closest === 'function' && target.closest('[data-metric-info]'));
}

// An information button that shows how a metric is calculated. Click to open;
// click it again, click outside or press Escape to close.
export function MetricInfo({ id, label, children }) {
    return (
        <OverlayTrigger
            trigger="click"
            placement="top"
            rootClose
            overlay={(
                <Popover id={id} className="floor-deck__formula-popover" data-metric-info="">
                    <Popover.Header as="h3">{label}</Popover.Header>
                    <Popover.Body>{children}</Popover.Body>
                </Popover>
            )}
        >
            <button
                type="button"
                className="floor-deck__info-button floor-deck__info-button--metric"
                aria-label={`How ${label} is calculated`}
                data-metric-info=""
            >
                <InfoOutlinedIcon aria-hidden="true" />
            </button>
        </OverlayTrigger>
    );
}
